var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('v-row',{staticClass:"ma-0 ma-md-2"},[_c('v-col',{attrs:{"cols":"12","sm":"12"}},[(!_vm.fleet_guid)?_c('fleet-listing-box'):_vm._e(),(_vm.fleet_guid)?_c('fleet-box',{attrs:{"fleet_guid":_vm.fleet_guid}}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }